export *                  from './test-icon.component';
export *                  from './test-info.component';

export {
    Test,
    TestResultCategories
}                         from '@Common/Elements/Tests/';